export const moneyCatalogFields = ({ selectOptionsYear }) => {
  return [
    {
      control: "autocomplete",
      label: "Έτος",
      name: "year",
      options: selectOptionsYear.map((option) => ({
        key: option.value,
        value: option.value,
      })),
    },
    {
      control: "autocomplete",
      label: "Κατάσταση",
      name: "status",
      options: [
        { key: "Εκκρεμεί", value: "0" },
        { key: "Επεξεργασία", value: "1" },
        { key: "Ολοκληρώθηκε", value: "2" },
        { key: "Απέτυχε", value: "3" },
      ],
    },
  ];
};
